module.exports = __webpack_public_path__ + "img/playbar_album.415ecae8.svg";